import { styled, s } from '@thesisedu/ui'

export const SAMLButtonIcon = styled.img`
  width: 1.5em;
  height: 1.5em;
  border-radius: ${s.var('radii.1')};
`
